export const PAGE_TITLE = 'Messaging Center';
export const PAGE_SUBTITLE = 'Send ad-hoc messages to your members';
export const CONFIGURE_PAGE_TITLE = 'Configure Messaging Campaign';
export const CONFIGURE_PAGE_SUBTITLE =
  'Reach & engage audiences instantly with targeted SMS & Push notifications.';
export const CAMPAIGN_LIST_PAGE_TITLE = 'SMS / Push Notifications';
export const DETAILS_PAGE_TITLE = 'Messaging Campaign';

export const GENERAL_ERROR_MESSAGE = 'Something went wrong. Please try again.';
